import React, { useEffect, useState } from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Divider,
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  CircularProgress,
  ListItem,
  List,
  ListItemAvatar,
  Avatar,
  ListItemText,
  ListItemSecondaryAction,
} from "@material-ui/core";
import FolderIcon from '@material-ui/icons/Folder';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import WarningIcon from '@material-ui/icons/Warning';

import SubscribeButton from "../../../../components/SubscribeButton";
import { ORGANIZATION_ALIAS } from "../../../../constants";
import { flattenResponse } from "../../../../utils/flatten";
import { formatExpiration } from "../../../../utils/utils";
import EditAccountDialog from "../../../../components/EditAccountDialog";
import '../../account.scss'
import isSubscribedHelper from '../../../../helpers/isSubscribedHelper'

const useStyles = makeStyles(() => ({
  root: {},
}));

const AccountDisplay = (props) => {
  const { user, updateUser, apiManager, className, history, subscriptionData, ...rest } = props;
  const classes = useStyles();
  
  const [isLoading, setIsLoading] = useState(false);
  const [person, setPerson] = useState("");
  const [message, setMessage] = useState({
    messageOpen: false,
    message: "",
    messageStrong: "",
    error: false,
  });
  const organization = localStorage.getItem('organization') ? JSON.parse(localStorage.getItem('organization')) : '';

  const getData = async () => {
    const id = user["sub"];

    const response = { list: [await apiManager.getUserMe(id, ORGANIZATION_ALIAS)] }; //response.list = [] for flattenResponse
  
    const flattened = flattenResponse(response);
    setPerson(flattened[0]); //only one line in array
    setIsLoading(false);
  };

  //GET INITIAL DATA
  useEffect(() => {
    setIsLoading(true);
    getData();
  }, []);


 const getCourseName = alias => {
    let position = organization.courses.findIndex(el => el.alias === alias);
    if(position !== -1){
      return organization.courses[position].name
    } else {
      return ''
    }
 }
  const renderSubscriptions = () => {
    let subscriptionStatus = [];
    person.organization_subscriptions.forEach((subscription) =>
      subscriptionStatus.push({
        name: getCourseName(subscription.courseNameAlias),
        expiry: formatExpiration(subscription.endDate),
        status: isSubscribedHelper(subscription.status).str  
      })
    );
    console.log(person.organization_subscriptions)
    
    return (
      <>
      <hr className="accountDisplay__subDivider" style={{color: '#cdcbcb'}}/>
      <h4>Subscriptions:</h4>
      <List>
        {subscriptionStatus.map((sub, index) => (
          <ListItem key={sub.name + index}>
            <ListItemAvatar>
              <Avatar>
                {sub.status === 'Subscribed' ? <CheckCircleIcon color="primary" fontSize="large"/> : <WarningIcon color="error" fontSize="large"/>}
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              children={
                <div className="accountDisplay__subscription-item">
                    <div>
                    <span className="accountDisplay__subscription-info">Course:</span> {sub.name}
                    </div>
                    <div>
                    <span className="accountDisplay__subscription-info">Status:</span> {sub.status}
                    <span className="accountDisplay__subscription-info">Expiration:</span> {sub.expiry}
                    </div>
                </div>}
            />
            {/* <ListItemSecondaryAction>
              <IconButton edge="end" aria-label="delete">
                <DeleteIcon />
              </IconButton>
            </ListItemSecondaryAction> */}
          </ListItem>
        ))}
        </List>
      </>
    );
  };
  const goToResetPW = async (event) => {
    event.preventDefault();
    history.push("/reset-password");
  };

  const [modalOpen, setModalOpen] = useState(false);

  const openEdit = () => {
    setModalOpen(true);
  };

  const handleClose = () => {
    setModalOpen(false);
  };
  const updateProfile = async (updatedData) => {
    setIsLoading(true);
    handleClose();
    const byName = `${user["custom:firstName"]} ${user["custom:lastName"]}`;
    const payload = { ...updatedData };
    payload.name_fullName =
      payload.name_firstName + " " + payload.name_lastName;
    payload.updatedBy = byName;
    payload.originalEmail = user.email; // in case email changed, need this to find the user in cognito
    payload.organization_name = ORGANIZATION_ALIAS;
    let response;
    response = await apiManager.adminUpdateUserProfile(payload);
    let message = "User profile updated.";
    let messageStrong = "";
    let error = false;
    if (!response || !response.data || response.data.error === true) {
      message = `User update failed. Error: ${
        !response || !response.data ? "service error" : response.data.message
      }}`;
      error = true;
    } else {
      getData();
    }
    setMessage({ messageOpen: false, message, messageStrong, error });
    handleClose();
    getData();
  };

  const renderMessage = () => {
    const { messageOpen, message, messageStrong } = message;
    return (
      <>
        <Dialog
          open={messageOpen}
          onClose={setMessage({
            messageOpen: false,
            message: "",
            messageStrong: "",
            error: "",
          })}
          aria-labelledby="system-message"
        >
          <DialogTitle id="System Message">
            <b>
              {this.state.error ? (
                <span style={{ color: "red" }}>There was a problem:</span>
              ) : (
                <span>Success</span>
              )}
            </b>
          </DialogTitle>
          <DialogContent>
            <DialogContentText style={{ minWidth: 240 }}>
              <p> {message} </p>
              {messageStrong && messageStrong !== "" && (
                <span style={{ fontWeight: "bold" }}>
                  <p style={{ color: "red", margin: 18 }}>PLEASE READ:</p>
                  <p style={{ margin: 18 }}>{messageStrong}</p>
                </span>
              )}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={setMessage({
                messageOpen: false,
                message: "",
                messageStrong: "",
                error: "",
              })}
              color="primary"
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  };
  return (
    <div className="accountDisplay">
      <Card {...rest} className={clsx(classes.root, className)}>
        <CardHeader
          //   subheader="Edit your profile information"
          title="Your Account"
        />
        <Divider />
        <CardContent>
          {isLoading ? (
            <div style={{ color: "#67b1e2" }}>
              <CircularProgress color="inherit" />
            </div>
          ) : (
            <Grid container spacing={3}>
              <Grid item md={9} xs={12}>
                <table>
                  <tbody>
                    <tr>
                      <td
                        style={{
                          width: 200,
                          fontWeight: "bold",
                          padding: "16px 8px",
                        }}
                      >
                        Email/User Id
                      </td>
                      <td>{person.email}</td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          width: 200,
                          fontWeight: "bold",
                          padding: "16px 8px",
                        }}
                      >
                        Name
                      </td>
                      <td>
                        {person.name_firstName} {person.name_lastName}
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          width: 200,
                          fontWeight: "bold",
                          padding: "16px 8px",
                        }}
                      >
                        Phone
                      </td>
                      <td>{person.phone}</td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          width: 200,
                          fontWeight: "bold",
                          padding: "16px 8px",
                        }}
                      >
                        Address
                      </td>
                      <td>
                        {person.addresses_mailing_address1}{" "}
                        {person.addresses_mailing_address2}
                        {person.addresses_mailing_city},{" "}
                        {person.addresses_mailing_state} &nbsp;{" "}
                        {person.addresses_mailing_postalCode} <br />{" "}
                        {person.addresses_mailing_country}
                      </td>
                    </tr>
                    
                  </tbody>
                </table>
                {person && person.organization_subscriptions[0] &&
                  renderSubscriptions()
                }
              </Grid>
            </Grid>
          )}
        </CardContent>
        <Divider />
        <CardActions>
          <Button
            variant="outlined"
            onClick={goToResetPW}
            style={{ margin: 24 }}
          >
            Update Password
          </Button>
          <Button
            color="primary"
            variant="outlined"
            onClick={openEdit}
            style={{ margin: 24 }}
          >
            Edit Account
          </Button>
        </CardActions>
      </Card>
      {modalOpen && (
        <EditAccountDialog
          open={modalOpen}
          close={handleClose}
          data={person}
          updateProfile={updateProfile}
        />
      )}
      {message.messageOpen && renderMessage()}
    </div>
  );
};
AccountDisplay.propTypes = {
  user: PropTypes.object.isRequired,
  apiManager: PropTypes.object.isRequired,
};

export default AccountDisplay;
